import { ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useClienteService } from "@services/ClienteService";
import React from "react";

export enum EnumClienteStatus {
    None = "0",
    Ativo = 1,
    Inativo = 2
}

export interface IClienteStatus {
    clienteStatusId: number
    nome: string
    ativo: string
}

export type IComboClienteStatus = ISpecializedCombo<IClienteStatus>;

export function useClienteStatusCombo (initialValue?: EnumClienteStatus) : IComboClienteStatus {
    const combo = useCombo<IClienteStatus>({
        value: initialValue
    });

    const clienteService = useClienteService();

    const createOptions = React.useCallback(() => {
        return combo.set.map((clienteStatus, index) => {
            return <MenuItem key={index} value={clienteStatus.clienteStatusId}>{ clienteStatus.nome }</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback(() => {
        combo.load(clienteService.listarStatusAtivos)
    }, [combo, clienteService.listarStatusAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}